import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { FC } from 'react'
import type { FarmQuantificationUnit } from '@/types/apiModels'
import { pairPaddocksByPredecessor } from '../helpers/pairPaddocksByPredecessor'

type StratificationQUsPaddockUsageTableProps = {
  qu: FarmQuantificationUnit
}

const EM_DASH = '—'

// Shared sx applied to the first cell of every "Proyecto" group row to produce
// a visible vertical separator between the two sides without adding a DOM element.
const groupDividerSx = {
  borderLeft: 1,
  borderLeftColor: 'divider',
}

const groupHeaderSx = {
  backgroundColor: 'action.hover',
  py: 0.5,
}

const subHeaderSx = {
  backgroundColor: 'action.selected',
  color: 'text.secondary',
  fontWeight: 'normal',
  py: 0.5,
}

export const StratificationQUsPaddockUsageTable: FC<StratificationQUsPaddockUsageTableProps> = ({
  qu,
}) => {
  const baseline = qu.paddocksByYear[qu.baselineYear] ?? []
  const project = qu.paddocksByYear[qu.improvementYear] ?? []
  const rows = pairPaddocksByPredecessor(baseline, project)

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell align="center" colSpan={2} sx={groupHeaderSx}>
            Línea de Base
          </TableCell>
          <TableCell align="center" colSpan={2} sx={{ ...groupDividerSx, ...groupHeaderSx }}>
            Proyecto
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell sx={subHeaderSx}>Lote</TableCell>
          <TableCell sx={subHeaderSx}>Práctica</TableCell>
          <TableCell sx={{ ...groupDividerSx, ...subHeaderSx }}>Lote</TableCell>
          <TableCell sx={subHeaderSx}>Práctica</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map(({ baseline: baselineEntry, project: projectEntry }, index) => (
          <TableRow
            // Index tiebreaks the rare case where both sides are null/orphans and the pair
            // identity alone collides; the row list is rebuilt deterministically each render.
            // eslint-disable-next-line react/no-array-index-key
            key={`${baselineEntry?.paddockId ?? 'none'}-${projectEntry?.paddockId ?? 'none'}-${index}`}
          >
            <TableCell>{baselineEntry?.paddockName ?? EM_DASH}</TableCell>
            <TableCell>{baselineEntry?.usageName ?? EM_DASH}</TableCell>
            <TableCell sx={groupDividerSx}>{projectEntry?.paddockName ?? EM_DASH}</TableCell>
            <TableCell>{projectEntry?.usageName ?? EM_DASH}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
